import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import Page from "@/pages/BlogPost";
import { getPostBySlug } from "@/data/blog-posts";
import { breadcrumbJsonLd, DEFAULT_OG_IMAGE, pageHead, SITE_URL } from "@/lib/seo";

// Slugs antigos (renomeados em fev/2026 e o erro de digitação "bagunda").
const LEGACY_SLUGS: Record<string, string> = {
  "por-que-morar-fora-bagunda-alimentacao-e-como-voltar-ao-eixo":
    "por-que-morar-fora-bagunca-alimentacao-e-como-voltar-ao-eixo",
  "como-manter-alimentacao-saudavel-morando-na-australia": "como-organizar-alimentacao-na-australia-com-rotina-corrida",
  "emagrecer-sem-dieta-restritiva-na-australia": "emagrecimento-sem-dieta-maluca-como-ter-constancia",
  "guia-compras-saudaveis-coles-woolworths": "o-que-comprar-no-coles-e-woolworths-para-comer-melhor",
  "meal-prep-semanal-para-brasileiros-na-australia": "como-montar-marmitas-na-australia-sem-passar-horas-cozinhando",
  "ansiedade-e-compulsao-alimentar-como-lidar": "ansiedade-e-comida-na-adaptacao-como-sair-do-8-ou-80",
};

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) throw redirect({ to: "/blog/$slug", params: { slug: target }, statusCode: 301 });
    const post = getPostBySlug(params.slug);
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) => {
    const post = loaderData?.post;
    if (!post) return {};
    const path = `/blog/${post.slug}`;
    return pageHead({
      title: post.seoTitle,
      description: post.metaDescription,
      path,
      ogType: "article",
      extraMeta: [
        { property: "article:published_time", content: post.date },
        { property: "article:modified_time", content: post.updated ?? post.date },
        { property: "article:author", content: "Clara Camille" },
        { property: "article:section", content: post.categoryLabel },
      ],
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: post.title,
          description: post.metaDescription,
          image: DEFAULT_OG_IMAGE,
          author: { "@type": "Person", name: "Clara Camille", jobTitle: "Nutricionista", url: `${SITE_URL}/sobre` },
          publisher: { "@id": `${SITE_URL}/#business` },
          datePublished: post.date,
          dateModified: post.updated ?? post.date,
          mainEntityOfPage: `${SITE_URL}${path}`,
        },
        breadcrumbJsonLd([
          { name: "Blog", path: "/blog" },
          { name: post.title, path },
        ]),
      ],
    });
  },
  component: Page,
});
